import { configureStore } from '@reduxjs/toolkit'
import authSlice from './slices/authSlice'
import userSlice from './slices/userSlice'
import locationSlice from './slices/locationSlice'
import appSlice from './slices/appSlice'
import userDataMiddleware from './middleware/userDataMiddleware'
import appMiddleware from './middleware/appMiddleWare'

export const store = configureStore({
  reducer: {
    auth: authSlice,
    user: userSlice,
    location: locationSlice,
    app: appSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(appMiddleware.middleware).prepend(userDataMiddleware.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
